import { Button, Form, Modal, notification } from "antd";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { createEvent } from "store/slices/eventsSlice";
import { closeModal } from "store/slices/modalsSlice";
import EventForm from "./event-form";

const NewEventModal = () => {
  const { t } = useTranslation();
  const [form] = Form?.useForm();
  const dispatch = useDispatch();
  const { isModalOpen, modalType } = useSelector((state) => state?.modals);
  const { loading } = useSelector((state) => state?.events);
  const open = isModalOpen && modalType === "new_event";

  // Dans la fonction onSubmit du composant NewEventModal
  const onSubmit = async (values) => {
  const formData = new FormData();

  // Image
  if (values?.image?.length > 0) {
   formData.append('image', values.image[0].originFileObj);

  }

  formData.append("title", values.title);

  // Common fields for all types
  if (values.postType === "article") {
    formData.append("excerpt", values.excerpt);
    formData.append("content", values.content);
  }

  if (values.postType === "testimonial") {
    formData.append("studentName", values.studentName);
    formData.append("testimonial", values.testimonial);
    if (values.videoUrl) formData.append("videoUrl", values.videoUrl);
  }

  if (values.postType === "video") {
    formData.append("videoUrl", values.videoUrl);
  }

  if (values.postType === "event") {
    formData.append("description", values.description);
    formData.append("format", values.format);
    if (values.format === "onsite" && values.location) {
      formData.append("location", values.location);
    }
    formData.append("eventDate", dayjs(values.eventDate).format("YYYY-MM-DD"));
    formData.append("eventTime", dayjs(values.eventTime).format("HH:mm"));
    formData.append("registrationLink", values.registrationLink);
  }

  const publishMode = values.publishMode || "immediate";
  if (publishMode === "scheduled" && values.publishDate && values.publishTime) {
    const publishDateTime = dayjs(values.publishDate)
      .hour(dayjs(values.publishTime).hour())
      .minute(dayjs(values.publishTime).minute())
      .second(0)
      .millisecond(0);
    formData.append("publishedAt", publishDateTime.toISOString());
  } else {
    formData.append("publishedAt", dayjs().toISOString());
  }

  formData.append("postType", values.postType); // Add type to form data

  try {
    await dispatch(createEvent(formData)).unwrap();
    notification.success({
      message: t("events.crud.form.success"),
    });
    form.resetFields();
    dispatch(closeModal());
  } catch (error) {
    notification.error({
      message: t("events.crud.form.error"),
      description: error.message || "Une erreur est survenue",
    });
  }
};


  return (
    <Modal
      title={t("events.crud.new")}
      open={open}
      onCancel={() => dispatch(closeModal())}
      width={700}
      footer={[
        <Button key="cancel" onClick={() => dispatch(closeModal())}>
          {t("common.cancel")}
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={() => form?.submit()}
        >
          {t("common.save")}
        </Button>,
      ]}
    >
      <EventForm form={form} onSubmit={onSubmit} />
    </Modal>
  );
};

export default NewEventModal;
